export default __webpack_public_path__ + "media/images/dashboard_icons/exclusive-designs-fd43f569afd3acb88c2357c79a2f3a20.svg";